import React, { useEffect, useState } from "react";
import "../../../../style/block.scss";
import "../../../../style/feature.scss";
import "./style.scss";
import "../../../../style/buttons.scss";
import "../../../../style/hovers.scss";
import "../../../../index.scss";
import { Exercise } from "../../../models/Exercise";
import { format } from "date-fns";
import { TbCalendarStats, TbTicket } from "react-icons/tb";
import { BsClock, BsPeople } from "react-icons/bs";
import { AiOutlineUserAdd } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import useExerciseInfo from "./useExerciseInfo";
import ExerciseInfoPassSelector from "./ExerciseInfoPassSelector";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import useFacility from "../../../../utils/hooks/useFacility";
import ExerciseInfoPassSelectorReservationList from "./ExerciseInfoPassSelectorReservationList";
import HtmlTooltip from "@mui/material/Tooltip";
interface IProps {
  exercise: Exercise;
  handleModals: (value: string) => void;
  joinToExercise: (value: boolean, passId: string) => void;
  alerts: string;
  assignedStatus: boolean;
  waitList: boolean;
  ticketsListLength: number;
}

const ExerciseInfo: React.FC<IProps> = ({ handleModals, exercise, joinToExercise, alerts, assignedStatus, waitList, ticketsListLength }) => {
  const { currentTimev2, loading, availablePasses } = useExerciseInfo();
  const { t } = useTranslation();
  const allowReservationByPassOnFitnessPlan = useSelector(
    (state: State) => state.config.configuration.allowReservationByPassOnFitnessPlan
  );
  const calendar_AllowSingleTickets = useSelector(
    (state: State) => state.config.configuration.calendar_AllowSingleTickets
  );
  const facilityIds = useFacility();
  const [reservedList, setReservedList] = useState(true);

  useEffect(() => {

    if (facilityIds === "1212") {
      if (exercise.capacity - (exercise.reserved + exercise.prereservation) < 0) {
        setReservedList(false)

      }
    }

  }, []);

  return (
    <React.Fragment>

      <div className="exercise-info">
        <div className="content">
          <div className="flex-start-center">
            <div className="flex-start-center">
              <TbCalendarStats className="icon-details" />

              <b> {format(exercise.startTime, "dd.MM.yyyy")}</b>
            </div>
            <div className="flex-start-center">
              <BsClock className="icon-details" />

              <b>{format(exercise.startTime, "HH:mm")}</b>
            </div>

            <div className="flex-start-center">
              <BsPeople className="icon-details" />

              <b>
                {exercise.reserved + exercise.prereservation}/{exercise.capacity}
              </b>
            </div>
          </div>

          {assignedStatus && waitList === false && <p className="alert-green alert">{t("jestes_zapisany")} </p>}
          <HtmlTooltip
            placement="bottom-start"
            title={
              <React.Fragment>
                <article
                  className="tooltip-description"
                  dangerouslySetInnerHTML={{ __html: "Zapisanie się na listę rezerwową spowoduje, że zapiszemy Cie do kolejki osób oczekujących na rezerwacje. Jeśli ktoś zrezygnuje, to zapiszemy Ciebie." }}
                ></article>
              </React.Fragment>
            }
          >
            <div>{waitList === true && <p className="alert-yellow alert">Lista rezerwowa</p>}</div>
          </HtmlTooltip>

          <article dangerouslySetInnerHTML={{ __html: exercise.description }}></article>




          {exercise.humanName && exercise.humanName.length > 1 && (
            <div className="coach flex-start-center">
              { exercise.humanPicture.length > 1 ? (
                <div className="coach-img" style={{ backgroundImage: `url(${exercise.humanPicture})` }}></div>
              ) : (
                <div className="coach-img-none coach-img "></div>
              )}

              <div className="coach-details">
                <b>{exercise.humanName}</b>
                <span>{t("trener_opiekun")}</span>
              </div>
            </div>
          )}

          {alerts.length > 1 && <p className="alert-red alert">{alerts}</p>}
          {currentTimev2 > exercise.saleFrom && currentTimev2 < exercise.saleTo && (
            <React.Fragment>
              <div className="flex-between-center buttons">
                {calendar_AllowSingleTickets && ticketsListLength > 0 && <button
                  onClick={() => handleModals("ticketsModal")}
                  className="button medium padding-small button-fill-main"
                >
                  {t("kup_jednorazowy_bilet")}
                  <TbTicket className="icon" />
                </button>}
                {allowReservationByPassOnFitnessPlan &&
                  <React.Fragment>
                    {assignedStatus ? (
                      <button
                        onClick={() => joinToExercise(true, "null")}
                        className="button medium padding-small button-warning"
                      >
                        {t("zrezygnuj")}
                        <AiOutlineUserAdd className="icon-second" />
                      </button>
                    ) : (
                      <React.Fragment>
                        {reservedList ? (<ExerciseInfoPassSelector
                          exerciseStart={exercise.startTime}
                          reservationList={reservedList}
                          loading={loading}
                          passesList={availablePasses}
                          joinToExercise={joinToExercise}
                        />) : (<ExerciseInfoPassSelectorReservationList
                          exerciseStart={exercise.startTime}
                          reservationList={reservedList}
                          loading={loading}
                          passesList={availablePasses}
                          joinToExercise={joinToExercise}
                        />)}
                      </React.Fragment>
                    )}
                  </React.Fragment>}
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ExerciseInfo;
